var render, staticRenderFns
import script from "./PieGraph.vue?vue&type=script&lang=js"
export * from "./PieGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986d64c",
  null
  
)

export default component.exports